import React from "react";
import { RequireStaff } from "@/components/RequireStaff";

export default function StaffCompanies() {
  return (
    <RequireStaff>
      <div className="font-['Geist',sans-serif]">
        <h1 className="text-xl font-semibold mb-4">Companies</h1>
        <div className="rounded-2xl p-5" style={{ background: "#1b2a3a" }}>
          <p className="text-gray-300 text-sm">
            Stub – Connect to your collection of legal entities (vendors/buyers/brokers/lenders/consultants).
          </p>
        </div>
      </div>
    </RequireStaff>
  );
}
